import { formatMoney } from "@archetype-themes/scripts/helpers/currency";

document.addEventListener("DOMContentLoaded", () => {
  const mainImageElement = document.querySelector(
    ".product-image-main .image-wrap img"
  );
  const bundleProductsSelectors = document.querySelectorAll(".bundle-product-selector");
  const imageThumbs = document.querySelector(
    ".product__thumbs .product__thumbs--scroller"
  );
  let firstImageThumb = null;

  if (!bundleProductsSelectors || !bundleProductsSelectors.length) {
    return;
  }
  if (imageThumbs?.children.length) {
    firstImageThumb = imageThumbs.children[0].querySelector(
      "a[data-product-thumb]"
    );
    firstImageThumb.addEventListener("click", (e) => {
      const imageUrl =
        e.target?.srcset ?? e.target?.querySelector("img")?.srcset;
      updateMainProductImage(imageUrl, mainImageElement);
    });
  }

  bundleProductsSelectors.forEach((selector) => {
    selector.addEventListener("change", handleSelectProduct);
  });

  const bundlePriceElement = document.getElementById(
    "boa-dropdown-bundle-price"
  );
  function handleSelectProduct(e) {
    const imageUrl = e.target?.selectedOptions[0]?.dataset?.mainImage;
    selectImageForBundleProduct(imageUrl, firstImageThumb, mainImageElement);

    if(!bundlePriceElement){
      return;
    }
    updateTotalPrice(bundleProductsSelectors, bundlePriceElement);
  }
});

function updateTotalPrice(productsSelectors, bundlePriceElement) {  
  let updatedBundlePrice = 0;
  productsSelectors.forEach((select) => {
    const price =
    parseShopifyPriceToNumber(select.selectedOptions[0].dataset?.productPrice) || 0;
    updatedBundlePrice += price;
  });
  updatedBundlePrice += parseShopifyPriceToNumber(bundlePriceElement.dataset.mainProductPrice);
  updatedBundlePrice *= 100;
  const priceHtml = formatMoney(
    updatedBundlePrice,
    "{" + "{" + "amount" + "}" + "}" + " ₪", // to avoid Liquid processing
    true
  );
  if (priceHtml) {
    const priceSpan = bundlePriceElement.querySelector(
      "span:not(.visually-hidden)"
    );
    priceSpan.innerHTML = priceHtml;
  }
}
function parseShopifyPriceToNumber(shopifyPrice){ // removing commas in case number more then 1000 for right parsing in parseFloat
  const stringPrice = shopifyPrice?.replace(/,/g, '');
  if(!stringPrice || !stringPrice.length){
    return 0;
  }
  return parseFloat(stringPrice);
}
function selectImageForBundleProduct(
  imageUrl,
  firstImageThumb,
  mainImageElement
) {
  if (firstImageThumb) {
    firstImageThumb.click(); // this method adds "is-active" class
    setTimeout(() => {
      firstImageThumb.classList.remove("is-active");
    }, 10); // need to wait till the click function will finish

    updateMainProductImage(imageUrl, mainImageElement);
  }
}
function updateMainProductImage(imageUrl, mainImageElement) {
  if (!imageUrl || imageUrl.includes("error")) {
    return;
  }
  mainImageElement.src = imageUrl;
  mainImageElement.srcset = imageUrl;
  mainImageElement.setAttribute("data-photoswipe-src", imageUrl);
}